export default __webpack_public_path__ + "static/media/PayatTable1.76bc4394.jpg";